import Http from "../../Utils/Http";
import {localDevCatch} from "../../Utils/utils";
import {mockedTemplates} from "../Instances/InstancesService.mock";

export const postExtendedRequest = async (request) => {
    const result = await Http.post(`/enrollments-api/requests`,request)
        .then(res => res.data)
        .catch((err) => localDevCatch(err))
    return result
}

export const getExtendedRequests = async () => {
    const result = await Http.get(`/enrollments-api/extended`)
        .then(res => res.data)
        .catch((err) => localDevCatch(err, mockedTemplates));
    return result;
}

export const deleteExtendedRequest = async (requestId) => {
    const result = await Http.delete(`/enrollments-api/extended/${requestId}`)
        .then(res => res.data)
        .catch((err) => localDevCatch(err, mockedTemplates));
    return result;
}

export const processExtendedRequest = async (requestId) => {
    const result = await Http.post(`/enrollments-api/extended/${requestId}/process`)
        .then(res => res.data)
        .catch((err) => localDevCatch(err, mockedTemplates));
    return result;
}

export const unprocessExtendedRequest = async (requestId) => {
    const result = await Http.post(`/enrollments-api/extended/${requestId}/unprocess`)
        .then(res => res.data)
        .catch((err) => localDevCatch(err, mockedTemplates));
    return result;
}

export const postExtendedFiles = async (requestId,files) => {
    let formData=new FormData()
    for(let file of files){
        formData.append("files",file)
    }
    let sessionId = sessionStorage.getItem("sessionId")
    let headers = new Headers({
        'Authorization': 'Bearer ' + sessionId
    });
    let endpoint = `/enrollments-api/extended/${requestId}/files`
    return await fetch(
        endpoint,
        {
            headers: headers,
            method: "POST",
            body: formData
        })
        .then(r => {
            if(r.ok) {
                return r.text()
            }else {
                return "Archivos no adjuntados"
            }
        })
        .catch(reason => {
            console.log(reason);
        })
}

export const getExtendedRequestFiles = async (requestId) => {
    let sessionId = sessionStorage.getItem("sessionId")
    let headers = new Headers({
        'Authorization': 'Bearer ' + sessionId
    });
    let endpoint = `/enrollments-api/extended/${requestId}/files`
    return await fetch(endpoint, {headers: headers})
        .then(r => {
            if(r.ok){
                r.blob()
                    .then((blob)=>{
                        // 1. filename
                        const filename = r.headers
                            .get("content-disposition")
                            .split('"')[1];
                        // 2. Create blob link to download
                        const url = window.URL.createObjectURL(new Blob([blob]))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', filename)
                        // 3. Append to html page
                        document.body.appendChild(link)
                        // 4. Force download
                        link.click()
                        // 5. Clean up and remove the link
                        link.parentNode.removeChild(link)
                    })
            }else {
                throw Error("Can't download file")
            }
        })
        .catch(reason => {
            console.error(reason)
            return reason
        })
}

export const getExtendedRequestPDF = async (requestId) => {
    let sessionId = sessionStorage.getItem("sessionId")
    let headers = new Headers({
        'Authorization': 'Bearer ' + sessionId
    });
    let endpoint = `/enrollments-api/extended/${requestId}/pdf`
    return await fetch(endpoint, {headers: headers})
        .then(r => r.blob())
        .then((blob)=>{
            // 2. Create blob link to download
            const url = window.URL.createObjectURL(new Blob([blob]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `peticion_automatricula_${requestId}.pdf`)
            // 3. Append to html page
            document.body.appendChild(link)
            // 4. Force download
            link.click()
            // 5. Clean up and remove the link
            link.parentNode.removeChild(link)
        })
        .catch(reason => {
            console.log(reason)
        })
}

export const getAllExtendedRequests = async () => {
    const result = await Http.get(`/enrollments-api/extended/all`)
        .then(res => res.data)
        .catch((err) => localDevCatch(err))
    return result
}

export const fetchExtendedCsvFile = async () =>{
    let sessionId = sessionStorage.getItem("sessionId")
    let headers = new Headers({
        'Authorization': 'Bearer ' + sessionId
    });
    let endpoint = `/enrollments-api/extended/csv`
    return await fetch(endpoint, {headers: headers})
        .then(r => r.blob())
        .then((blob)=>{
            // 2. Create blob link to download
            const url = window.URL.createObjectURL(new Blob([blob]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `selfenrollments.csv`)
            // 3. Append to html page
            document.body.appendChild(link)
            // 4. Force download
            link.click()
            // 5. Clean up and remove the link
            link.parentNode.removeChild(link)
        })
        .catch(reason => {
            console.log(reason)
        })
}